import { JobDetails, QueueStrategy } from "../types";

export class FifoQueueStrategy implements QueueStrategy {
  getNext(jobEntries: [string, JobDetails][]) {
    const unstartedJobs = jobEntries
      .filter(([key, job]) => !job.startedAt)
      .sort((a, b) => a[1].queuedAt.getTime() - b[1].queuedAt.getTime());

    if (unstartedJobs.length === 0) return;

    return unstartedJobs[0];
  }
}
